"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BoldIcon", {
  enumerable: true,
  get: function get() {
    return _BoldIcon.BoldIcon;
  }
});
Object.defineProperty(exports, "ItalicsIcon", {
  enumerable: true,
  get: function get() {
    return _ItalicsIcon.ItalicsIcon;
  }
});
Object.defineProperty(exports, "SendButton", {
  enumerable: true,
  get: function get() {
    return _SendButton.SendButton;
  }
});
Object.defineProperty(exports, "SmileyFace", {
  enumerable: true,
  get: function get() {
    return _SmileyFace.SmileyFace;
  }
});
var _BoldIcon = require("./BoldIcon");
var _ItalicsIcon = require("./ItalicsIcon");
var _SendButton = require("./SendButton");
var _SmileyFace = require("./SmileyFace");